import {
  GetCustomizeCar_customizeCar_availableFeatureCategories,
  GetCustomizeCar_customizeCar_availableFeatures,
} from '../graphql/queries/__generated__/GetCustomizeCar';
import CategoryPurpose from '../enum/CategoryPurpose';

function getExteriorCategoryCode(featureCategories?: GetCustomizeCar_customizeCar_availableFeatureCategories[]) {
  return featureCategories?.find(
    featureCategory => featureCategory.attributes.categorypurpose === CategoryPurpose.EXTERIOR_COLOUR,
  )?.code;
}

function getInteriorCategoryCode(featureCategories?: GetCustomizeCar_customizeCar_availableFeatureCategories[]) {
  return featureCategories?.find(
    featureCategory => featureCategory.attributes.categorypurpose === CategoryPurpose.INTERIOR_COLOUR,
  )?.code;
}

export function getColorFeatureCodes(
  featureCategories?: GetCustomizeCar_customizeCar_availableFeatureCategories[],
  features?: GetCustomizeCar_customizeCar_availableFeatures[],
) {
  const exteriorCategoryCode = getExteriorCategoryCode(featureCategories);
  const interiorCatrgoryCode = getInteriorCategoryCode(featureCategories);

  if ((!exteriorCategoryCode && !interiorCatrgoryCode) || !features) {
    return [];
  }

  return features
    .filter(feature => feature.categoryCode === exteriorCategoryCode || feature.categoryCode === interiorCatrgoryCode)
    .map(feature => feature.code);
}
